module.exports = "/../../dist/frontend/images/R-DAM_1385359_mobile.webp?0189ff6ebbf690791680529b0da60b8b";